import { RefObject, useEffect } from 'react';

export function usePageChoreography(ref: RefObject<HTMLDivElement>, disabled: boolean, route: string) {
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    let frame = 0;
    const hero = root.querySelector<HTMLElement>('.editorial-hero');
    const update = () => {
      frame = 0;
      const progress = Math.min(1, window.scrollY / Math.max(1, document.documentElement.scrollHeight - innerHeight));
      root.style.setProperty('--page-progress', String(progress));
      root.style.setProperty('--page-depth', disabled ? '0px' : `${Math.min(110, window.scrollY * .16)}px`);
      root.classList.toggle('is-scrolled', window.scrollY > 30);
      hero?.classList.toggle('is-past', hero.getBoundingClientRect().bottom < 0);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const elements = root.querySelectorAll<HTMLElement>('[data-page-reveal]');
    const observer = !disabled && 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer?.unobserve(entry.target); } });
    }, { threshold: .08 }) : null;
    elements.forEach(el => { if (observer) { el.classList.add('page-will-reveal'); observer.observe(el); } else el.classList.add('is-visible'); });
    update();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    const resize = new ResizeObserver(schedule);
    resize.observe(root);
    return () => {
      cancelAnimationFrame(frame); observer?.disconnect(); resize.disconnect();
      window.removeEventListener('scroll', schedule); window.removeEventListener('resize', schedule);
      elements.forEach(el => el.classList.remove('page-will-reveal'));
    };
  }, [ref, disabled, route]);
}
